<div class="contenedor">
    <div *ngIf="!load" class="spinner">
        <mat-spinner [diameter]="60"></mat-spinner>
    </div>
    <div *ngIf="load && dataSource.data.length == 0" class="spinner">
        <h3>No Hay Tratos Cargados</h3>
    </div>
    <div [ngClass]="{'oculto': dataSource.data.length == 0}">
        <table mat-table [dataSource]="dataSource" class="w-100" matSort (matSortChange)="sortData($event)">
            <ng-container matColumnDef="titulo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Trato
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <h6> {{ element.titulo }} </h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="finalidad">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Tipo Solicitud
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <h6>{{ element.finalidad }}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="nombreMandante">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Mandante
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <h6>{{ element.nombreMandante }}</h6>
                </td>
            </ng-container>

            <ng-container matColumnDef="ultimaFecha">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Fecha Act.
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <h6>{{ element.ultimaFecha | date : 'dd/MM/yyyy' }} - {{ element.ultimaFecha | date: 'HH:mm' }}Hrs.</h6>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="dealAmount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Monto
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <h6>{{ element.dealAmount | currency:'CLP':'symbol' }}</h6>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="comision">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Comisión
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <h6>{{ element.comision | currency:'CLP':'symbol' }}</h6>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="position">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Estado
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1" style="font-weight: bold;">
                    <!--<h6 *ngIf="element.position == 'Perdido'" style="color: red;">{{ element.position }}</h6>
                    <h6 *ngIf="element.position == 'Abierto'">{{ element.position }}</h6>
                    <h6 *ngIf="element.position == 'Ganado'" style="color: green;">{{ element.position }}</h6>
                    <h6 *ngIf="!element.position"> Abierto </h6>-->

                    <h6 style="font-weight: bold" *ngIf="element.ultimoEstado==0">Pendiente</h6>
                    <h6 style="color: green; font-weight: bold;" *ngIf="element.ultimoEstado==1">Aprobado</h6>
                    <h6 style="color: red; font-weight: bold;" *ngIf="element.ultimoEstado==2">Rechazado</h6>
                    <h6 style="color: #b2b505; font-weight: bold;" *ngIf="element.ultimoEstado==3">Requiere Informacion</h6>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="razonDealP">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                Razón
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6 *ngIf="!element.razonDealP"> - </h6>
                <h6 *ngIf="element.razonDealP">{{ element.razonDealP }}</h6>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="commitDealP">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                Detalle
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                <h6 *ngIf="!element.commitDealP"> - </h6>
                <h6 *ngIf="element.commitDealP">{{ element.commitDealP }}</h6>
                </td>
            </ng-container>
    
            <ng-container matColumnDef="executiveName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="th-title">
                    Ejecutivo
                </th>
                <td mat-cell *matCellDef="let element" class="mat-body-1">
                    <h6>{{ element.executiveName }}</h6>
                </td>
            </ng-container>
    
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" class="cursor-table" style="cursor: pointer;" (click)="openModalDetaiDeals(row)">
            </tr>
        </table>
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" [length]="paginator.length" [pageSize]="paginator.pageSize" (page)="changePaginationTable($event)"
            showFirstLastButtons>
        </mat-paginator>
    </div>
</div>